import { computed, isRef } from 'vue';
import { useAdminEventActivityStore } from '@hds/admin-client-pinia-vue-sdk';
import { useSaleAndAssetsStore } from '../stores/sale-and-assets.store.js';

export function useEvent(eventId) {
  if (!isRef(eventId)) {
    throw new Error('eventId must be a ref')
  }

  const eventActivityStore = useAdminEventActivityStore();
  const saleAndAssetsStore = useSaleAndAssetsStore();

  // VIBE-SERVER DATA — the event's id is its sale's id
  const sale = computed(() => {
    return saleAndAssetsStore.sales[eventId.value];
  })

  const runListItemIds = computed(() => {
    return sale.value?.runList;
  })

  const nextItemId = computed(() => {
    const idx = runListItemIds.value?.indexOf(assetOnBlockId.value);
    return idx != null ? runListItemIds.value?.[idx + 1] : undefined;
  })

  const prevItemId = computed(() => {
    const idx = runListItemIds.value?.indexOf(assetOnBlockId.value);
    return idx != null ? runListItemIds.value?.[idx - 1] : undefined;
  })

  // EVENT RUNTIME DATA
  const eventActivity = computed(() => {
    return eventActivityStore.events[eventId.value];
  })

  const eventStatus = computed(() => {
    return eventActivity.value?.status;
  })

  const assetOnBlockId = computed(() => {
    return eventActivity.value?.onBlock[0];
  })


  return {
    sale,
    runListItemIds,
    nextItemId,
    prevItemId,
    eventActivity,
    eventStatus,
    assetOnBlockId
  }
}
